import { commaSeparatedList } from 'utils/utils';

export function getQuickFilterOptions(filters) {
	if (!filters) return;
	return Object.entries(filters).map(([name, data]) => {
		let allowedValues;
		if (typeof data === 'string') {
			allowedValues = commaSeparatedList(data);
		} else if (name === 'combinedLanguage') {
			allowedValues = Object.values(data);
		}
		return { name, allowedValues };
	});
}